import { render, staticRenderFns } from "./LogoPublic.vue?vue&type=template&id=62cba2ec"
import script from "./LogoPublic.vue?vue&type=script&lang=js"
export * from "./LogoPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports